import omit from 'lodash/omit'
import { runJsonGet } from '@/backend-client'
import { transformKeysToSnakeCase, transformKeysToCamelCase } from './utils/casing'
import { OPERATIONS_BACKEND_URL } from '@/config'
import { Timestamp, formatWithDots, humanizeIsoTime, humanizeIsoDate } from 'plankton'

const transformInboundStop = stop => {
  const tz = stop.warehouseAddress.timezone
  const result = {
    ...omit(stop, ['arrivalToWarehouse', 'departureFromWarehouse']),
    arrivalToWarehouse: new Timestamp(stop.arrivalToWarehouse, tz),
    departureFromWarehouse: new Timestamp(stop.departureFromWarehouse, tz),
    date: stop.arrivalToWarehouse
      ? formatWithDots(humanizeIsoDate(stop.arrivalToWarehouse))
      : '',
    startTime: stop.arrivalToWarehouse ? humanizeIsoTime(stop.arrivalToWarehouse) : '',
    endTime: stop.departureFromWarehouse
      ? humanizeIsoTime(stop.departureFromWarehouse)
      : ''
  }
  if (stop.contactPerson) {
    result.contactPerson = {
      ...stop.contactPerson,
      name: `${stop.contactPerson.firstName} ${stop.contactPerson.lastName}`
    }
  }

  return result
}

/**
 * @param {number} orderId
 * @returns {Promise<OrderStopFetch[]>}
 * TO DO: Create OrderStopFetch interface for typescript
 */
export const fetchOrderStops = async orderId => {
  const response = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/ordering/queries/get-order-stops`,
    transformKeysToSnakeCase({ orderId })
  )
  const result = transformKeysToCamelCase(response.data) as Array<any>
  return result.map(transformInboundStop)
}
